import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Box from '../Layout/Flex/Box';
import Typography from '../Styles/Typography/Typography';
import Button from '../Buttons/Button/Button';
import Spacer from '../Layout/Spacer/Spacer';
const NotFoundStyle = styled.div `
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const NotFoundPage = () => {
    const navigate = useNavigate();
    return (_jsx(NotFoundStyle, { children: _jsxs(Box, Object.assign({ column: true, alignItems: "center", justifyContent: "center" }, { children: [_jsx(Typography, Object.assign({ size: "title", color: "main" }, { children: "404" })), _jsx(Typography, Object.assign({ size: "note", color: "gray" }, { children: "page not found" })), _jsx(Spacer, { vertical: true }), _jsx(Button, { onClick: () => navigate('/'), text: "Home" })] })) }));
};
export default NotFoundPage;
